// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U7dO","top":"styles_top__1yyxq"};